import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgBinanceSmartChain = function SvgBinanceSmartChain(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#F3BA2F",
        d: "M118.191 74.514c-8.013 32.143-40.569 51.705-72.716 43.69C13.342 110.19-6.22 77.632 1.797 45.492 9.807 13.345 42.363-6.218 74.5 1.795c32.144 8.014 51.705 40.575 43.691 72.72"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M60 38.08 44.463 53.617v-.001l-9.039-9.04L60 20l24.584 24.583-9.04 9.04zM29.04 50.958 20 60l9.04 9.038 9.04-9.04zm15.423 15.426L60 81.92l15.544-15.543 9.045 9.035-.005.005L60 100 35.424 75.424l-.013-.013zm46.497-15.42-9.04 9.04 9.04 9.04 9.04-9.04z",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M69.169 59.995h.004L60 50.822 53.22 57.6l-.779.78-1.606 1.606-.013.012.013.014L60 69.178l9.173-9.173.005-.005z"
    })));
};

export { SvgBinanceSmartChain as ReactComponent };
//# sourceMappingURL=BinanceSmartChain.svg.es.js.map
